import * as R from "ramda";
import React, { useMemo, useState } from "react";
import { Button, message, Popover, Input } from "antd";
import { CopyToClipboard } from "react-copy-to-clipboard";

import { QrcodeAsImage } from "@/components/Common/GalleryPreview";

export const VisitorVideoGenerate = (props) => {
  const orderId = R.pathOr("", ["match", "params", "orderid"], props) * 1;
  const [exhibitorName, setExhibitorName] = useState("");
  const [exhibitorNumber, setExhibitorNumber] = useState("");

  const url = useMemo(() => {
    if (!orderId || !exhibitorName || !exhibitorNumber) return "";
    const encodedName = encodeURIComponent(exhibitorName);
    const encodedNumber = encodeURIComponent(exhibitorNumber);
    return `http://consumer.jimage.cn/thirdparty/video/generate?orderId=${orderId}&durable_title=${encodedName}&durable_title_second=${encodedNumber}`;
  }, [orderId, exhibitorName, exhibitorNumber]);

  const popoverContent = (
    <div style={{ width: 380, padding: "12px 8px" }}>
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 6, fontSize: 14, color: "#666" }}>展商名称</div>
        <Input
          placeholder="请输入展商名称"
          value={exhibitorName}
          onChange={(e) => setExhibitorName((e.target.value || "").trim())}
          style={{ width: "100%" }}
          allowClear
        />
      </div>
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 6, fontSize: 14, color: "#666" }}>展商号</div>
        <Input
          placeholder="请输入展商号"
          value={exhibitorNumber}
          onChange={(e) => setExhibitorNumber((e.target.value || "").trim())}
          style={{ width: "100%" }}
          allowClear
        />
      </div>
      {url ? (
        <>
          <div style={{ marginBottom: 12 }}>
            <div style={{ marginBottom: 6, fontSize: 14, color: "#666" }}>生成的URL</div>
            <Input.TextArea
              rows={2}
              value={url}
              readOnly
              style={{ width: "100%", background: "#f5f5f5", fontSize: 12 }}
            />
          </div>
          <div style={{ marginBottom: 12, textAlign: "center", padding: "8px 0" }}>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              title="点击在新窗口打开"
            >
              <QrcodeAsImage url={url} />
            </a>
          </div>
          <CopyToClipboard text={url}>
            <Button
              type="primary"
              icon="copy"
              onClick={() => {
                message.success("复制成功");
              }}
              block
              style={{ height: 36 }}
            >
              复制链接
            </Button>
          </CopyToClipboard>
        </>
      ) : (
        <div
          style={{
            padding: "20px 0",
            textAlign: "center",
            color: "#999",
            fontSize: 14,
            background: "#fafafa",
            borderRadius: 4,
            border: "1px dashed #d9d9d9",
          }}
        >
          请先输入展商名称和展商号
        </div>
      )}
    </div>
  );

  return (
    <Popover content={popoverContent} placement="bottom">
      <Button>访客视频生成</Button>
    </Popover>
  );
};


// WEBPACK FOOTER //
// ./src/containers/Video/widgets/visitor-video.js